<template>
  <div>
    <template v-if="item.isSuccess">
      <v-card-title :class="{'card-bg-2 font-weight-medium py-1': isRoot, 'pt-2 pb-1': !isRoot }">
        The rollback removed:
      </v-card-title>
      <v-card-text class="py-2">
        <div v-for="(dataKey,i) in serviceKeys" :key="i">
          <v-icon :color="dataKey.color" class="no-transition mr-1">
            {{ dataKey.icon ? dataKey.icon : getMediaTypeIcon(item.media_type) }}
          </v-icon>
          <span>
            {{ item[dataKey.key] }}
          </span>
          <span :class="{ 'grey--text text--darken-1': !hover }" class="">
            {{ pluralize(dataKey.displayName, item[dataKey.key]) }}
          </span>
        </div>
      </v-card-text>
      <template v-if="rollbackItem">
        <v-divider />
        <v-card-title class="card-bg-2 font-weight-medium py-0">
          Referenced import details
          <TertiaryBtn :to="{ name: 'allimports', query: { search: rollbackItem.executionId } }" small icon="find_in_page">Go to import</TertiaryBtn>
        </v-card-title>
        <v-divider />
        <DefaultRun v-if="rollbackItem" :hover="hover" :item="rollbackItem" />
      </template>
    </template>
    <v-card-text v-else>
      The rollback process failed. View the logs for details.
    </v-card-text>
  </div>
</template>

<script>
  import { pluralize } from '@/helpers/strings'
  import { serviceKeys } from '@/helpers/datasets/ingestions'
  import { getMediaTypeIcon } from '@/helpers/mediaTypes'

  export default {
    components: {
      // https://stackoverflow.com/a/58875919/12161614
      DefaultRun: () => import('./DefaultRun'),
    },
    props: {
      isRoot: Boolean,
      item: Object,
      hover: Boolean,
    },
    data: () => ({
      serviceKeys,
    }),
    computed: {
      rollbackItem() {
        return this.item && this.item.rollbackDetail
      },
    },
    methods: {
      pluralize,
      getMediaTypeIcon,
    },
  }
</script>